import { api } from '@/shared/api'
import { Bank, ORDContragent, ORDMarkingFormData } from '@synapex/prisma/client'
import { LinkDescriptor } from '@synapex/shared2/entities'
import {
    ContragentResponse,
    CreateCustomActInputDto,
    CreateCustomContractInputDto,
    CreateVkOrdApiKeyInputDto,
    CreateVkOrdContragentInputDto,
    CustomActWithType,
    GetContragentsInputDto,
    LinkDescriptorDto,
    UpdateCustomActInputDto,
    UpdateCustomContractInputDto,
    UpdateMarkingFormDataInputDto,
    UpdateVkOrdApiKeyInputDto,
    UpdateVkOrdContragentInputDto,
    VkOrdApiKeyResponse,
    VkOrdHistoryResponse,
    WorkspaceDescriptorDto,
} from '@synapex/shared2/gateway-rest-api'
import { pickDto } from '../utils'

export const setUserVkOrdKey = (input: CreateVkOrdApiKeyInputDto) => {
    return api.post(
        '/ord/vk-ord-key',
        pickDto(CreateVkOrdApiKeyInputDto, input)
    )
}

export const updateUserAdditionalOrdData = (
    wd: WorkspaceDescriptorDto,
    input: UpdateVkOrdApiKeyInputDto
) => {
    return api.put<VkOrdApiKeyResponse>(
        '/ord/additional-data',
        pickDto(UpdateVkOrdApiKeyInputDto, input),
        {
            params: pickDto(WorkspaceDescriptorDto, wd),
        }
    )
}

export const deleteUserVkOrdKey = (wd: WorkspaceDescriptorDto) => {
    return api.delete('/ord/vk-ord-key', {
        params: pickDto(WorkspaceDescriptorDto, wd),
    })
}

export const createContragent = (contragent: CreateVkOrdContragentInputDto) => {
    return api.post<ORDContragent>(
        '/ord/contragents',
        pickDto(CreateVkOrdContragentInputDto, contragent)
    )
}

export const getContragents = (input: GetContragentsInputDto) => {
    return api.get<ContragentResponse[]>('/ord/contragents', {
        params: pickDto(GetContragentsInputDto, input),
    })
}

export const getBanks = (search?: string) => {
    return api.get<Bank[]>('/ord/banks', { params: { search } })
}

export const getBankByBic = (bic: string) => {
    return api.get<Bank>(`/ord/banks/${bic}`)
}

export const getVkOrdHistory = (linkDescriptor: LinkDescriptor) => {
    return api.get<VkOrdHistoryResponse[]>('/ord/vk-ord-history', {
        params: pickDto(LinkDescriptorDto, linkDescriptor),
    })
}

export const getMarkingFormData = (linkDescriptor: LinkDescriptor) => {
    return api.get<ORDMarkingFormData>('/ord/marking-form-data', {
        params: pickDto(LinkDescriptorDto, linkDescriptor),
    })
}

export const updateMarkingFormData = (input: UpdateMarkingFormDataInputDto) => {
    return api.put<ORDMarkingFormData>(
        '/ord/marking-form-data',
        pickDto(UpdateMarkingFormDataInputDto, input)
    )
}

export const createMarkingFormData = (input: UpdateMarkingFormDataInputDto) => {
    return api.post<ORDMarkingFormData>(
        '/ord/marking-form-data',
        pickDto(UpdateMarkingFormDataInputDto, input)
    )
}

export const copyVkOrdApiKey = (wd: WorkspaceDescriptorDto) => {
    return api.post<string>('/ord/vk-ord-key/copy', undefined, {
        params: pickDto(WorkspaceDescriptorDto, wd),
    })
}

export const createCustomContract = (input: CreateCustomContractInputDto) => {
    return api.post<unknown>(
        '/ord/custom-contracts',
        pickDto(CreateCustomContractInputDto, input)
    )
}

export const updateCustomContract = (
    customContractId: number,
    input: UpdateCustomContractInputDto
) => {
    return api.put<unknown>(
        `/ord/custom-contracts/${customContractId}`,
        pickDto(UpdateCustomContractInputDto, input)
    )
}

export const createCustomAct = (input: CreateCustomActInputDto) => {
    return api.post<CustomActWithType>(
        '/ord/custom-acts',
        pickDto(CreateCustomActInputDto, input)
    )
}

export const updateCustomAct = (
    customActId: number,
    input: UpdateCustomActInputDto
) => {
    return api.put<unknown>(
        `/ord/custom-acts/${customActId}`,
        pickDto(UpdateCustomActInputDto, input)
    )
}
